import { useOrganization } from 'core/stores/hooks/useOrganization';
import { extractQueryListItems } from 'core/utils/apollo/extractListItems';
import { useGetPlanMembershipByOrganizationQuery } from 'generated-graphql/hooks/apollo-hooks';
import { SubscriptionProduct } from 'generated-graphql/types';
import { useSetRecoilState } from 'recoil';
import { planMembershipAtom } from 'services/billing/atoms';

export const usePlanMemberships = () => {
  const organization = useOrganization();
  const setPlanState = useSetRecoilState(planMembershipAtom);

  const { data } = useGetPlanMembershipByOrganizationQuery({
    // Deliver partial data when one field errors; 'none' discards the result.
    errorPolicy: 'all',
    variables: {
      organizationId: organization.id
    },
    onCompleted: (data) => {
      const planMemberships = extractQueryListItems(data);
      setPlanState(planMemberships);
    }
  });

  const scoreUsage = data?.getPlanMembershipByOrganization?.items.find(
    (item) => item?.product === SubscriptionProduct.PoppScoring
  );
  const conversationUsage = data?.getPlanMembershipByOrganization?.items.find(
    (item) => item?.product === SubscriptionProduct.PoppConversations
  );

  return {
    scoreUsage,
    conversationUsage
  };
};
